import { render, staticRenderFns } from "./PaymentReceiptButton.vue?vue&type=template&id=4f5f4aee"
import script from "./PaymentReceiptButton.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports